export const MAIN_CATEGORY_TILE_CLICKED = 'Main Category Tile Clicked'
export const MAIN_CATEGORY_TILE_VIEWED = 'Main Category Tile Viewed'
export const CONTENT_LOADED = 'Content Loaded'
